import React from "react";

/**
 * Badge de situação/gravidade reutilizado nas abas de Validação Fiscal.
 * variant: "success" | "warning" | "danger" | "neutral" | "dark"
 */
export default function StatusPill({ children, variant = "neutral" }) {
  return <span className={`status-pill ${variant}`}>{children}</span>;
}
